import React, { Component, PropTypes } from 'react';
import moment from 'moment';

import LiveMoment from '../LiveMoment';
import ButtonIcon from '../ButtonIcon';

import S from './style.css';
import bellImage from './bell.svg';

export default class ChannelListItemActions extends Component {
  static propTypes = {
    isPinging: PropTypes.bool,
    lastPingAt: PropTypes.number,
    pingChannel: PropTypes.func.isRequired,
  }

  static defaultProps = {
    isPinging: false,
  }

  render() {
    const {
      isPinging,
      lastPingAt,
      pingChannel,
    } = this.props;

    return (
      <div className="mb2">
        <LiveMoment className="db silver" date={lastPingAt}>
          {m => {
            const title = m.isValid() ?
              `Last pinged ${m.twitterLong()}` : 'not yet pinged';

            let buttonText = 'Ping';
            let buttonClasses = '';

            if (m.isValid() && moment().diff(m, 'seconds') < 60) {
              buttonText = 'Pinged!';
              buttonClasses += ' o-60';
            }

            return (
              <ButtonIcon
                className={`${buttonClasses} ${isPinging && S.pinging}`}
                iconImage={bellImage}
                onClick={pingChannel}
                title={title}
              >
                {buttonText}
              </ButtonIcon>
            );
          }}
        </LiveMoment>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/ChannelListItemActions/index.jsx
 **/